import React from 'react';

import { useIntl } from 'react-intl-next';

import Heading from '@atlaskit/heading';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Stack, xcss } from '@atlaskit/primitives';

import { messages } from '../../../../../messages';

import AlertIcon from './assets/alert-icon.svg';

interface ErrorSectionProps {
	description?: React.ReactNode;
	header?: string;
}

const descriptionStyles = xcss({
	textAlign: 'center',
	paddingTop: 'space.100',
});

export const ErrorSection = (props: ErrorSectionProps): React.JSX.Element => {
	const intl = useIntl();

	const {
		header = intl.formatMessage(messages.errorDefaultHeader),
		description = intl.formatMessage(messages.errorDefaultDescription),
	} = props;

	return (
		<Stack alignInline="center">
			<Box padding="space.400">
				<img src={AlertIcon} height="103" aria-label={intl.formatMessage(messages.alertIcon)} />
			</Box>
			<Heading size="small">{header}</Heading>
			<Box xcss={descriptionStyles}>{description}</Box>
		</Stack>
	);
};
